<template>
<div>
    <Loading
        v-model:active="loading"
        :can-cancel="false"
        :widh="100"
        :height="100"
        :is-full-page="true"
        :opacity="0.7"
        color="#0dcaf0"
        background-color="#000"
    ></Loading>
    <div class="wrap">
        <div class="card" role="region" aria-label="付款資訊卡片">
            <div class="card-container">
                <div class="brand-badge">
                    <img :src="audiLogo" alt="AUDI Logo" class="badge-logo" /> X
                    <img :src="evoasisLogo" alt="EVOASIS Logo" class="badge-logo" />
                </div>
                
                <div v-if="!loading" class="brand">
                    <div>
                        <h1 class="text-left">安裝作業進度查詢</h1>
                        <p class="lead" style="justify-self: start;">訂單編號：#{{orderNumber}}</p>
                    </div>
                </div>
                <div v-if="!loading" class="status-box text-left">目前狀態：[ <span style="color: #00aeba" >{{ currentStatus }}</span> ]</div>

                <div class="steps">
                    <!-- Repeatable step item -->
                    <div 
                        class="step" :class="item._log?.status=='done' ? 'done' : item._log?.status=='opposite' ? 'opposite' : currentStep == item.step ? 'active' : ''"
                        v-for="item in steps" :key="item.step"
                    >
                        <div class="icon"></div>
                        <div class="date">{{ item._log ? moment(item._log?.timestamp).utcOffset(8).format('YYYY-MM-DD HH:mm') : '' }}</div>
                        <div class="content">
                            <div class="label">{{ stepTitle(item) }}</div>
                        </div>
                        
                    </div>

                    <!-- <div class="step done">
                        <div class="icon"></div>
                        <div class="date">\{\{step2_time\}\}</div>
                        <div class="content">
                            <div class="label">付款完成</div>
                        </div>
                        
                    </div>

                    <div class="step active">
                        <div class="icon"></div>
                        <div class="date">\{\{step3_time\}\}</div>
                        <div class="content">
                            <div class="label">排程中</div>
                        </div>
                    </div>

                    <div class="step">
                        <div class="icon"></div>
                        <div class="date"></div>
                        <div class="content">
                            <div class="label">安裝中</div>
                        </div>
                    </div>

                    <div class="step">
                        <div class="icon"></div>
                        <div class="date"></div>
                        <div class="content">
                            <div class="label">已完成</div>
                        </div>
                    </div> -->
                </div>
            </div>
            
            <footer class="small-center">
                <p>如有任何問題，歡迎聯繫 EVOASIS，將有專員為您協助。<br>服務專線：06-602-0889 • Email：help@evoasis.com.tw</p>
            </footer>
        </div>
    </div>
</div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import Loading from 'vue-loading-overlay'
import axios from "axios";
import moment from 'moment'
import audiLogo from '@/assets/img/audi.svg';
import evoasisLogo from '@/assets/img/evoasis.svg';

const route = useRoute()
const loading = ref(true)
const orderId = ref(route.params.orderId)
const orderNumber = ref()
const currentStep = ref(1)
const progressLog = ref([])

const stepDefinitions = [
    
    { step: 1, title: "待付款", done: "已付款", opposite: "已退款" },
    { step: 2, title: "待發包安裝商", done: "已發包安裝商" },
    { step: 3, title: "待安裝商回應", done: "安裝商已同意", opposite: "安裝商已拒絕" },
    { step: 4, title: "待聯繫客戶", done: "客戶已同意場勘", opposite: "客戶拒絕場勘" },
    { step: 5, title: "待場勘", done: "現場場勘 / 照片報價" },
    { step: 6, title: "待報價", done: "客戶同意報價", opposite: "客戶不同意報價" },
    { step: 6.5, title: "待處理" },
    { step: 7, title: "待發貨", done: "已發貨" },
    { step: 8, title: "待安裝", done: "已安裝" }
];

onMounted(() => {
    document.title = route.meta.title;
})

onBeforeMount(async () => {
    try {
        await fetchOrderStatus()
    } catch (error) {
        console.log(error);
    }
});

const fetchOrderStatus = async() => {
    const { data: orderStatusResponse } = await axios.get(`https://api.evoasis.com.tw/portal/wix/order/audi/${orderId.value}/status`)
    orderNumber.value = orderStatusResponse.orderNumber
    progressLog.value = orderStatusResponse.progressLog
    currentStep.value = orderStatusResponse.step
    loading.value = false
}
// 取最新 log
const latestLogByStep = computed(() => {
    const grouped = {};
    progressLog.value.forEach((log) => {
        const step = log.step;
        // 忽略大於 currentStep 的 log
        if (currentStep.value != -1 && step >= currentStep.value) return;
        
        if (!grouped[step]) grouped[step] = log;
        else {
            const prev = new Date(grouped[step].timestamp);
            const now = new Date(log.timestamp);
            if (now > prev) grouped[step] = log;
        }
    });
    return grouped;
});

const currentStatus = computed(() => 
    currentStep.value == -1 ? '已退款' : currentStep.value > 8 ? '已安裝' : stepDefinitions.find(item => item.step == currentStep.value)?.title
);

const steps = computed(() =>
    stepDefinitions
    .filter(l => l.step != 6.5)
    .map((s) => ({
        ...s,
        _log: latestLogByStep.value[s.step],
    }))
);

const stepTitle = (item) => {
    if (item._log?.status === "done") {
        if(item.step === 5)  return "安裝商已場勘"
        return item.done || item.title;
    }
    if (item._log?.status === "opposite") return item.opposite || item.title;
    return item.title;
};
</script>

<style lang="scss" scoped>
body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
        margin: 0;
        background: #f9fafb;
        color: #111827;
}

.wrap{
    min-height:90vh;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align: initial;
    padding:32px 0 18px;
}

.card {
    position: relative;
    width:100%;
    max-width:880px;
    background:var(--card);
    border-radius:var(--radius);
    box-shadow:var(--shadow);
    overflow:hidden;
}

@media (max-width:880px){
    .card{
        grid-template-columns:1fr;
        max-width:420px
    }
}

.card-container{
    padding:32px 36px;
}
.brand{
    display:flex;
    gap:12px;
}
.logo{
    width:44px;
    height:44px;
    border-radius:10px;
    background:var(--accent1);
    display:flex;
    align-items:center;
    justify-content:center;
    color:white;
    font-weight:700;
    box-shadow:0 6px 18px rgba(59,130,246,0.18);
}
h1{
    font-size:18px;
    margin:0;
}
p.lead{
    margin:6px 0 18px;
    color:var(--muted);
    font-size:13px
}

.radio-buttons {
    display: flex;
    gap: 8px;
    flex-wrap:wrap;
}

.radio-buttons input[type="radio"] {
    display: none;
}

.radio-buttons label {
    flex:1;
    font-size: 16px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 10px;
    cursor: pointer;
    background: #f9f9f9;
    margin-bottom: 0;
    color: var(--bs-body-color);
}

.radio-buttons input[type="radio"]:checked + label {
    background: var(--accent1);
    color: white;
    border: none;
}

form{
    display:flex;
    flex-direction:column;
    gap:14px
}
.row{
    display:flex;
    gap:12px
}
.field{
    flex:1;
    display:flex;
    flex-direction:column
}
label{
    font-size:14px;
    color:var(--muted);
    margin-bottom:8px
}

.small{font-size:12px;color:var(--muted)}

.badge{
    background:#f1f5f9;
    color:#0f172a;
    padding:6px;
    margin-left: 5px;
    border-radius:5px;
    font-size:12px;
    border:1px solid #e6edf6
}

.box{
    background:#ffffff;
    padding:12px;
    border-radius:10px;
    border:1px solid #f0f4f8
}
.muted{
    color:var(--muted);
    font-size:13px
}

footer.small-center{
    font-size:12px;
    color:var(--muted);
    text-align:center;
    padding:14px
}

.text-left { text-align: left; }
.brand-badge {
    padding: 6px 0 20px;
    margin-bottom: 25px;
    display: flex;
    gap: 20px;
    border-bottom: 1px dashed #eef2f7;
    align-items: center;
    z-index: 10;
}
.brand-badge::after {
    content: '';
    width: 100%;
    height: 5px;
    border-radius: 12px;
    background: var(--accent1);
}

.badge-logo {
    height: 24px;
    width: auto;
}

header {
    background: linear-gradient(90deg, #0ea5a4, #06b6d4);
    color: white;
    padding: 16px 24px;
    font-size: 20px;
    font-weight: 600;
}
.container {
    max-width: 680px;
    margin: 32px auto;
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.title {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 12px;
}
.meta {
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 24px;
}
.steps {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.step {
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
}
.step::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 22px;
    width: 1px;
    height: 100%;
    background: #e5e7eb;
}
.step:last-child::before {
    display: none;
}
.step .date {
    font-size: 14px;
    color: #6b7280;
}
.icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    background: #ffffff;
    box-shadow:0 6px 18px rgba(59,130,246,0.18);
    z-index: 1;
}
.step.done .icon {
    background: var(--accent1);
    border: none;
    color: white;
}
.step.active .icon {
    background: linear-gradient(135deg, #facc15 0%, #f97316 100%);
    border: none;
    color: white;
}
.step.opposite .icon {
    background: linear-gradient(135deg, #f87171 0%, #b91c1c 100%);
    border: none;
    color: white;
}

.content .label {
    font-weight: 600;
    font-size: 16px;
}

footer {
    text-align: center;
    font-size: 13px;
    color: #6b7280;
}
.status-box {
    background: #f6f6f6;
    color: #111;
    padding: 10px 14px;
    border-radius: 6px;
    margin-bottom: 24px;
}
@media (max-width: 480px) {
    .container {
        margin: 16px;
        padding: 20px;
    }
}
</style>